import mar from '@loggi/mar';

export const shadow = {
  standard: '0px 4px 8px rgba(0, 0, 0, 0.25)'
};

export default [...mar.shadows, shadow.standard];
